import React from 'react';
import { css } from '@linaria/core';

const containerClassname = css`
  position: relative;
  display: flex;
  margin-bottom: 8px;
`;

const radioClassname = css`
  border: 1px solid black;
  -webkit-appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 10px;
  margin: 0;
  cursor: pointer;
  &:checked {
    background-color: #000;
    &::before {
      content: '';
      position: absolute;
      width: 8px;
      height: 8px;
      top: 6px;
      left: 6px;
      border-radius: 4px;
      background-color: #fff;
    }
  }
`;

const labelClassname = css`
  font-size: 14px;
  padding: 2px 5px 1px 5px;
  margin-left: 3px;
  align-self: center;
`;

const Radio = ({ isSelected, label = null, style: overwriteStyles = {}, ...attr }) => {
  return (
    <div className={containerClassname} style={overwriteStyles}>
      <input className={radioClassname} type="radio" id={attr.value} checked={isSelected} {...attr} />
      {label && <label htmlFor={attr.value} className={labelClassname}>{label}</label>}
    </div>
  );
};

export default Radio;
